<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    @if (_isLoading) {
    <app-loading-box></app-loading-box>
    }

    <form class="form" [formGroup]="uploadForm">
      <div class="title-wrapper">
        <h1 class="title-default">Configuração Certificado Digital</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="cancelar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configuração do seu certificado A1
        </p>
      </div>

      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">verified_user</mat-icon>
          <span>Certificado atual</span>
        </div>

        @if (certificado) {
        <div class="certificado-info">
          <div class="info-item">
            <img src="assets/images/certificate-ilustration.png" class="icon-certificate" />
            <span class="info-label">Data de Vencimento:</span>
            <span class="info-value" [class.vencido]="isVencido()">
              {{ certificado.dataVencimento | date: 'dd/MM/yyyy' }}
              @if (isVencido()) {
              <strong> (Vencido)</strong>
              }
            </span>
          </div>
        </div>
        <div class="actions">
          <div class="row g-3 align-items-center">
            <div class="col-12 col-md-6">
              <div class="d-flex flex-wrap gap-2 actions-primary">
                <button type="button" mat-stroked-button class="btn-secondary" (click)="baixarCertificado()">
                  <mat-icon class="material-symbols-outlined">download</mat-icon>
                  Baixar
                </button>
                <button type="button" mat-stroked-button class="btn-secondary" (click)="visualizarSenha()">
                  <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                  Visualizar Senha
                </button>
              </div>
            </div>
            <div class="col-12 col-md-6 d-flex justify-content-md-end">
              <button type="button" mat-button (click)="removerCertificado()">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                Remover certificado
              </button>
            </div>
          </div>
        </div>
        } @else {
        <app-alert-card [type]="'warning'" [closable]="false">
          Vamos começar? Adicione seu Certificado A1 para liberar a emissão de documentos fiscais.
        </app-alert-card>
        }
      </div>

      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
          <span>Enviar novo certificado</span>
        </div>

        <div
          class="drop-zone"
          [class.drop-zone--file]="uploadForm.get('nomeArquivo')?.value"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()">
          <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pfx" hidden />
          @if (uploadForm.get('nomeArquivo')?.value) {
          <mat-icon class="drop-icon drop-icon--ok">check_circle</mat-icon>
          <p class="drop-title">{{ uploadForm.get('nomeArquivo')?.value }}</p>
          <p class="drop-subtitle">Clique para trocar</p>
          } @else {
          <mat-icon class="drop-icon">upload_file</mat-icon>
          <p class="drop-title">Clique para enviar ou arraste e solte</p>
          <p class="drop-subtitle">Formato aceito: PFX (certificado A1)</p>
          }
        </div>

        <div class="row">
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Senha do Certificado</mat-label>
              <input matInput formControlName="senhaCertificado" type="password" placeholder="Digite a senha" />
              @if (uploadForm.get('senhaCertificado')?.hasError('required')) {
              <mat-error>Informe a senha</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <app-footer-action
      (salvar)="confirmarEnvioCertificado()"
      (cancelar)="cancelar()"
      [isLoadingSalvar]="_isLoading"
      [isSalvarDisabled]="uploadForm.invalid"
      salvarLabel="Enviar certificado">
    </app-footer-action>

  </div>
</div>
